import { render, staticRenderFns } from "./claim-form.vue?vue&type=template&id=7fedb4f0&scoped=true"
import script from "./claim-form.vue?vue&type=script&lang=js"
export * from "./claim-form.vue?vue&type=script&lang=js"
import style0 from "./claim-form.vue?vue&type=style&index=0&id=7fedb4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fedb4f0",
  null
  
)

export default component.exports